/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MoveModuleTop = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.5 6.5V4.5H11.5V6.5H2.5ZM1 4C1 3.44772 1.44772 3 2 3H12C12.5523 3 13 3.44772 13 4V7C13 7.55228 12.5523 8 12 8H2C1.44772 8 1 7.55228 1 7V4ZM2.5 13V11H11.5V13H2.5ZM1 10.5C1 9.94772 1.44772 9.5 2 9.5H12C12.5523 9.5 13 9.94772 13 10.5V13.5C13 14.0523 12.5523 14.5 12 14.5H2C1.44772 14.5 1 14.0523 1 13.5V10.5ZM2.5 17.5V19.5H11.5V17.5H2.5ZM2 16C1.44772 16 1 16.4477 1 17V20C1 20.5523 1.44772 21 2 21H12C12.5523 21 13 20.5523 13 20V17C13 16.4477 12.5523 16 12 16H2ZM15 6.32895L16.0983 7.35192L18.2002 5.25005V20.9863H19.7002V5.25007L21.8021 7.35193L22.9004 6.32896L20.0109 3.4394C19.4251 2.85361 18.4753 2.85361 17.8896 3.4394L15 6.32895Z"
                        fill={color}
                    />
                </svg>
        );
    };
